export const ORDER = "/order/:mode/:id/:tab?";
export const ORDER_VIEW = "/order/view/:id/:tab?";
export const ORDER_EDIT = "/order/edit/:id/:tab?";
export const ORDER_DIAGNOSTIC_EDIT = "/order/diagnostic/edit/:id";

export const getOrderViewUrl = (id: string, tab?: string): string => {
  return tab ? `/order/view/${id}/${tab}` : `/order/view/${id}`;
};
